var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 15.8333H35.8334V33.3333C35.8334 33.7754 35.6578 34.1993 35.3453 34.5119C35.0327 34.8244 34.6088 35 34.1667 35H5.83341C5.39139 35 4.96746 34.8244 4.6549 34.5119C4.34234 34.1993 4.16675 33.7754 4.16675 33.3333V15.8333ZM4.16675 7.50001C4.16675 7.05798 4.34234 6.63406 4.6549 6.3215C4.96746 6.00894 5.39139 5.83334 5.83341 5.83334H34.1667C34.6088 5.83334 35.0327 6.00894 35.3453 6.3215C35.6578 6.63406 35.8334 7.05798 35.8334 7.50001V15.8333H4.16675V7.50001Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 21.6667H16.6667M13.3334 3.33334V10V3.33334ZM26.6667 3.33334V10V3.33334ZM23.3334 28.3333H28.3334H23.3334ZM11.6667 28.3333H16.6667H11.6667ZM23.3334 21.6667H28.3334H23.3334Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesIcon);
export default __webpack_public_path__ + "static/media/servicesIcon.6099e6c3a8f548edab5a450b9f668a94.svg";
export { ForwardRef as ReactComponent };